import { useNavigate } from 'react-router-dom';
import useCredentials from '../../../Hooks/useCredentials';
import { RootState, useAppSelector } from '../../../store';
import AdminBox from '../../Utility/AdminBox';
import AdminContainer from '../../Utility/AdminContainer';
import AdminViewContent from '../../Utility/AdminViewContent';
import AdminViewHeader from '../../Utility/AdminViewHeader';
import { Button } from '../../Utility/Button';
import { Credential } from '../../../Types';
import { PencilSimpleIcon, TrashIcon } from '@phosphor-icons/react';
import { PaginationListType } from '../../../Types/PaginationParams';
import { credentialsService } from '../../../Services/credentialsService';
import PaginatedView from '../../Utility/PaginatedView';
import { getBreakpoint } from '../../../utils/breakpoint';

function Credentials() {
    const navigate = useNavigate();
    const i18n = useAppSelector((state: RootState) => state.i18n.i18n);
    const windowWidth = useAppSelector((state: RootState) => state.environment.windowWidth);
    
    const handleNavigate = (path: string) => {
        navigate(path);
    };
    const { CredentialsActions } = useCredentials();

    const GRID_COLS = 'grid-cols-[minmax(157px,300px),minmax(157px,1fr)]';

    return (
        <div className={`admin-container flex relative flex-col`}>
            <AdminContainer>
                <AdminBox classString="px-4">
                    <PaginatedView
                        listType={PaginationListType.Credentials}
                        itemsFunction={credentialsService.getCredentialsByPage}
                        itemsPerPage={15}
                        renderItem={(credential: Credential, index: number) => (
                            <AdminViewContent
                                key={credential.identifier}
                                mobile={windowWidth < getBreakpoint('md')}
                                identifier={credential.identifier}
                                gridCols={GRID_COLS}
                                cols={{
                                    optionalCols: [
                                        {
                                            content: credential.name ?? '',
                                        },
                                    ],
                                    button: {
                                        buttons: [
                                            {
                                                variant: 'primaryRound',
                                                onClick: () => handleNavigate(credential.identifier),
                                                icon: <PencilSimpleIcon />,
                                            },
                                            {
                                                variant: 'secondaryRound',
                                                onClick: () =>
                                                    CredentialsActions.handleOpenConfirmDialog(credential.identifier),
                                                icon: <TrashIcon />,
                                            },
                                        ],
                                    },
                                }}
                            />
                        )}
                    >
                        {({ list, filter }) => (
                            <>
                                {filter}
                                <div className="hidden md:block">
                                    <AdminViewHeader
                                        gridCols={GRID_COLS}
                                        cols={{
                                            cols: [
                                                {
                                                    text: i18n.translate({
                                                        id: 'adminHeader.mainCol',
                                                        sourceName: 'Main',
                                                    }),
                                                },
                                            ],
                                            button: {
                                                text: i18n.translate({
                                                    id: 'newCredential.button',
                                                    sourceName: 'Credentials',
                                                }),
                                                function: () => handleNavigate('new'),
                                            },
                                        }}
                                    />

                                    <hr className="border-layout-borderColor mt-5" />
                                </div>

                                <div className="mb-4 block md:hidden">
                                    <Button
                                        className="!m-0 !mb-3 flex justify-center items-center w-full"
                                        onClick={() => handleNavigate('new')}
                                    >
                                        {i18n.translate({ id: 'newCredential.button', sourceName: 'Credentials' })}
                                    </Button>
                                </div>
                                {list}
                            </>
                        )}
                    </PaginatedView>
                </AdminBox>
            </AdminContainer>
        </div>
    );
}

export default Credentials;
